<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditPaPayroll" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="类型" prop="PaPayroll.type">
            <el-select class="input-item" v-model="formData.PaPayroll.type" :clearable="true" filterable
              placeholder="类型" :loading="EditPaPayroll.type.impl.loading"
              @visible-change="EditPaPayroll.type.impl.onVisibleChange"
              @change="onTypeValueChange">
              <el-option v-for="item in EditPaPayroll.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="名称" prop="PaPayroll.name">
            <el-input class="input-item" v-model="formData.PaPayroll.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态" prop="PaPayroll.status">
            <el-select class="input-item" v-model="formData.PaPayroll.status" :clearable="true" filterable
              placeholder="状态" :loading="EditPaPayroll.status.impl.loading"
              @visible-change="EditPaPayroll.status.impl.onVisibleChange"
              @change="onStatusValueChange">
              <el-option v-for="item in EditPaPayroll.status.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年度" prop="PaPayroll.paYear">
            <el-date-picker class="input-item" v-model="formData.PaPayroll.paYear" :clearable="true"
              format="yyyy" value-format="yyyy" type="year" align="left" placeholder="年度"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="月份" prop="PaPayroll.paMonth">
            <el-date-picker class="input-item" v-model="formData.PaPayroll.paMonth" :clearable="true"
              format="yyyyMM" value-format="yyyyMM" type="month" align="left" placeholder="月份"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="季度" prop="PaPayroll.paQuarter">
            <el-select class="input-item" v-model="formData.PaPayroll.paQuarter" :clearable="true" filterable
              placeholder="季度" :loading="EditPaPayroll.paQuarter.impl.loading"
              @visible-change="EditPaPayroll.paQuarter.impl.onVisibleChange"
              @change="onPaQuarterValueChange">
              <el-option v-for="item in EditPaPayroll.paQuarter.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="日期" prop="PaPayroll.paDay">
            <el-date-picker class="input-item" v-model="formData.PaPayroll.paDay" :clearable="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              type="date" align="left"
              placeholder="日期"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开启绩效" prop="PaPayroll.paFlag">
            <el-select class="input-item" v-model="formData.PaPayroll.paFlag" :clearable="true" filterable
              placeholder="开启绩效" :loading="EditPaPayroll.paFlag.impl.loading"
              @visible-change="EditPaPayroll.paFlag.impl.onVisibleChange"
              @change="onPaFlagValueChange">
              <el-option v-for="item in EditPaPayroll.paFlag.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8"  v-if="formData.PaPayroll.paFlag==='Y'">
          <el-form-item label="计算方式" prop="PaPayroll.scoreMethod">
            <el-select class="filter-item" v-model="formData.PaPayroll.scoreMethod" placeholder="计算方式">
              <el-option v-for="item in formData.scoreMethodList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.PaPayroll.paFlag==='Y'">
          <el-form-item label="得分系数" prop="PaPayroll.scoreRatio" label-width="110px">
            <el-input-number class="input-item" v-model="formData.PaPayroll.scoreRatio"
                             :clearable="true"
                             placeholder="绩效得分对应金额系数"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.PaPayroll.paFlag==='Y'">
          <el-form-item label="绩效总金额"  label-width="110px">
            <el-input-number class="input-item" v-model="formData.PaPayroll.paTotalAmount"
              :clearable="true"
              placeholder="绩效总金额"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.PaPayroll.paFlag==='Y'">
          <el-form-item label="绩效开始时间" prop="PaPayroll.paStartTime" label-width="110px">
            <el-date-picker class="input-item" v-model="formData.PaPayroll.paStartTime" :clearable="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              type="date" align="left"
              placeholder="绩效开始时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.PaPayroll.paFlag==='Y'">
          <el-form-item label="绩效截至时间" prop="PaPayroll.paEndTime" label-width="110px">
            <el-date-picker class="input-item" v-model="formData.PaPayroll.paEndTime" :clearable="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 23:59:59"
              type="date" align="left"
              placeholder="绩效截至时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.PaPayroll.paFlag==='Y'">
          <el-form-item label="绩效总分数" prop="PaPayroll.paTotalScore">
            <el-input class="input-item" v-model="formData.PaPayroll.paTotalScore" :disabled="true"
              :clearable="true" placeholder="绩效总分数"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.PaPayroll.paFlag==='Y'">
          <el-form-item label="考评开始时间" prop="PaPayroll.assessStartTime" label-width="110px">
            <el-date-picker class="input-item" v-model="formData.PaPayroll.assessStartTime" :clearable="true" :disabled="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              type="date" align="left"
              placeholder="考评开始时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.PaPayroll.paFlag==='Y'">
          <el-form-item label="考评结束时间" prop="PaPayroll.assessEndTime" label-width="110px">
            <el-date-picker class="input-item" v-model="formData.PaPayroll.assessEndTime" :clearable="true" :disabled="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              type="date" align="left"
              placeholder="考评结束时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditPaPayroll:EditPaPayroll:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaPayrollController, DictionaryController } from '@/api';

export default {
  name: 'EditPaPayroll',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaPayroll: {
          id: undefined,
          type: undefined,
          name: undefined,
          status: undefined,
          paYear: undefined,
          paMonth: undefined,
          paQuarter: undefined,
          paDay: undefined,
          paFlag: undefined,
          paTotalAmount: undefined,
          paStartTime: undefined,
          paEndTime: undefined,
          paTotalScore: undefined,
          assessStartTime: undefined,
          assessEndTime: undefined,
          assessTotalScore: undefined,
          scoreRatio: undefined,
          totalUserNum: undefined,
          totalPayrollAmount: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          scoreMethod: undefined,
          paPayrollLine: {
          },
          paPayrollIndex: {
          },
          isDatasourceInit: false
        },
        scoreMethodList: [{
          value: '1',
          label: '总金额分配'
        }, {
          value: '2',
          label: '得分对应分配'
        }]
      },
      rules: {
        'PaPayroll.status': [
          {required: true, message: '请输入状态', trigger: 'blur'}
        ],
        'PaPayroll.paYear': [
          {required: true, message: '请输入年度', trigger: 'blur'}
        ],
        'PaPayroll.type': [
          {required: true, message: '请输入类型', trigger: 'blur'}
        ],
        'PaPayroll.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        'PaPayroll.paFlag': [
          {required: true, message: '开启绩效', trigger: 'blur'}
        ],
        'PaPayroll.paTotalAmount': [
          {required: true, message: '绩效总金额', trigger: 'blur'}
        ],
        'PaPayroll.scoreMethod': [
          {required: true, message: '请选择计算方式', trigger: 'blur'}
        ],
        'PaPayroll.paStartTime': [
          {required: true, message: '绩效开始时间', trigger: 'blur'}
        ],
        'PaPayroll.paEndTime': [
          {required: true, message: '绩效截至时间', trigger: 'blur'}
        ]
      },
      EditPaPayroll: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        status: {
          impl: new DropdownWidget(this.loadStatusDropdownList)
        },
        paQuarter: {
          impl: new DropdownWidget(this.loadPaQuarterDropdownList)
        },
        paFlag: {
          impl: new DropdownWidget(this.loadPaFlagDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_payroll_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 状态下拉数据获取函数
     */
    loadStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_payroll_status'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 状态选中值改变
     */
    onStatusValueChange (value) {
    },
    /**
     * 季度下拉数据获取函数
     */
    loadPaQuarterDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_payroll_quarter'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 季度选中值改变
     */
    onPaQuarterValueChange (value) {
    },
    /**
     * 开启绩效下拉数据获取函数
     */
    loadPaFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 开启绩效选中值改变
     */
    onPaFlagValueChange (value) {
      if (value !== 'Y') {
        this.formData.PaPayroll.paTotalAmount = undefined;
        this.formData.PaPayroll.paStartTime = undefined;
        this.formData.PaPayroll.paEndTime = undefined;
      }
    },
    /**
     * 更新编辑工资发放
     */
    refreshEditPaPayroll (reloadData = false) {
      this.loadPaPayrollData().then(res => {
        if (!this.EditPaPayroll.isInit) {
          // 初始化下拉数据
          this.EditPaPayroll.type.impl.onVisibleChange(true).catch(e => {});
          this.EditPaPayroll.status.impl.onVisibleChange(true).catch(e => {});
        }
        this.EditPaPayroll.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditPaPayroll.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            typeDictMap: findItemFromList(this.EditPaPayroll.type.impl.dropdownList, this.formData.PaPayroll.type, 'id'),
            statusDictMap: findItemFromList(this.EditPaPayroll.status.impl.dropdownList, this.formData.PaPayroll.status, 'id'),
            paQuarterDictMap: findItemFromList(this.EditPaPayroll.paQuarter.impl.dropdownList, this.formData.PaPayroll.paQuarter, 'id'),
            paFlagDictMap: findItemFromList(this.EditPaPayroll.paFlag.impl.dropdownList, this.formData.PaPayroll.paFlag, 'id'),
            ...this.formData.PaPayroll
          };
          this.onCancel(true, formData);
          return;
        }

        if (this.formData.PaPayroll.scoreMethod === '1' && !this.formData.PaPayroll.paTotalAmount) {
          this.$message.error('操作失败!分配总金额不能为空!');
          return;
        }
        if (this.formData.PaPayroll.scoreMethod === '2' && !this.formData.PaPayroll.scoreRatio) {
          this.$message.error('操作失败!得分系数不能为空!');
          return;
        }
        let params = {
          paPayrollDto: {
            id: this.id,
            type: this.formData.PaPayroll.type,
            name: this.formData.PaPayroll.name,
            status: this.formData.PaPayroll.status,
            paYear: this.formData.PaPayroll.paYear,
            paMonth: this.formData.PaPayroll.paMonth,
            paQuarter: this.formData.PaPayroll.paQuarter,
            paDay: this.formData.PaPayroll.paDay,
            paFlag: this.formData.PaPayroll.paFlag,
            paTotalAmount: this.formData.PaPayroll.paTotalAmount,
            paStartTime: this.formData.PaPayroll.paStartTime,
            paEndTime: this.formData.PaPayroll.paEndTime,
            paTotalScore: this.formData.PaPayroll.paTotalScore,
            assessStartTime: this.formData.PaPayroll.assessStartTime,
            assessEndTime: this.formData.PaPayroll.assessEndTime,
            assessTotalScore: this.formData.PaPayroll.assessTotalScore,
            scoreRatio: this.formData.PaPayroll.scoreRatio,
            totalUserNum: this.formData.PaPayroll.totalUserNum,
            totalPayrollAmount: this.formData.PaPayroll.totalPayrollAmount,
            scoreMethod: this.formData.PaPayroll.scoreMethod
          }
        };

        PaPayrollController.update(this, params).then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    /**
     * 获取工资发放详细信息
     */
    loadPaPayrollData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaPayroll.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaPayrollController.view(this, params).then(res => {
            this.formData.PaPayroll = {...res.data, isDatasourceInit: true};
            if (this.formData.PaPayroll.typeDictMap && this.EditPaPayroll.type.impl.dirty) {
              this.EditPaPayroll.type.impl.dropdownList = [this.formData.PaPayroll.typeDictMap];
            }
            if (this.formData.PaPayroll.statusDictMap && this.EditPaPayroll.status.impl.dirty) {
              this.EditPaPayroll.status.impl.dropdownList = [this.formData.PaPayroll.statusDictMap];
            }
            if (this.formData.PaPayroll.paQuarterDictMap && this.EditPaPayroll.paQuarter.impl.dirty) {
              this.EditPaPayroll.paQuarter.impl.dropdownList = [this.formData.PaPayroll.paQuarterDictMap];
            }
            if (this.formData.PaPayroll.paFlagDictMap && this.EditPaPayroll.paFlag.impl.dirty) {
              this.EditPaPayroll.paFlag.impl.dropdownList = [this.formData.PaPayroll.paFlagDictMap];
            }
            if (this.formData.PaPayroll.paYear) {
              this.formData.PaPayroll.paYear = this.formData.PaPayroll.paYear + '';
            }
            if (this.formData.PaPayroll.paMonth) {
              this.formData.PaPayroll.paMonth = this.formData.PaPayroll.paMonth + '';
            }

            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaPayroll: {
          id: undefined,
          type: undefined,
          name: undefined,
          status: undefined,
          paYear: undefined,
          paMonth: undefined,
          paQuarter: undefined,
          paDay: undefined,
          paFlag: undefined,
          paTotalAmount: undefined,
          paStartTime: undefined,
          paEndTime: undefined,
          paTotalScore: undefined,
          assessStartTime: undefined,
          assessEndTime: undefined,
          assessTotalScore: undefined,
          scoreRatio: undefined,
          totalUserNum: undefined,
          totalPayrollAmount: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          scoreMethod: undefined,
          paPayrollLine: {
          },
          paPayrollIndex: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditPaPayroll();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaPayroll = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
